export interface TreatmentStatus {
    id: number
    name: string
}

export const defaultTreatmentStatus: TreatmentStatus = {
    id: 0
    , name: ''
}